import React from 'react'
import { Link } from 'react-router-dom';

// import thumb from '../../../assets/img/details/project-big-img.jpg'
import thumb from '../../../assets/img/speaker.jpg'


import img1 from '../../../assets/img/details/0.jpg'
import img2 from '../../../assets/img/details/1.jpg'
import img3 from '../../../assets/img/details/2.jpg'

const imagegallery = [
    { img: img1 },
    { img: img2 },
    { img: img3 },
]

function Details(props) {
    return (
        <section className="project-details section-gap">
            <div className="container">
                <div className="project-thumb">
                    <img src={thumb} alt="" />
                </div>
                <div className="project-content mt-60">
                    <div className="row">
                        <div className="col-lg-8 order-2 order-lg-2">
                            <div className="content">
                                <h2>Leveraging and Integrating Remote/Virtual Teams</h2>
                                <p className="mb-40">
                                    He takes you thru an in-depth gameplan on leveraging remote/virtual teams to
                                    grow your business, improve your bottom line, and bring your vision to realty.
                                    First-hand experience with over 1,000 team members allows his experience to
                                    be shared, and the important 10 tips for success.
                                </p>

                                <div className="col-12 order-3">
                                    <div className="thumbs">
                                        <div className="row justify-content-center">
                                            {imagegallery.map((item, i) => (
                                                <div key={i} className="col-md-4 col-sm-6 text-center">
                                                    <img src={item.img} alt="" />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <h2>Leading Through the Storms</h2>
                                <p>
                                    Leading a business thru times of success and growth can be fun, beneficial and
                                    satisfying. Conversely, mastering the leadership required to lead thru tough
                                    times, trials and unfriendly territory takes a mental preparedness and detailed
                                    game plan. With three simple rules to follow, you can learn what it takes to lead
                                    thru the storm.
                                </p>

                                {/* <div className="col-12 order-3">
                                    <div className="thumbs">
                                        <div className="row justify-content-center">
                                            {imagegallery.map((item, i) => (
                                                <div key={i} className="col-md-4 col-sm-6 text-center">
                                                    <img src={item.img} alt="" />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div> */}

                                <br />
                                <br />


                                <h2>Favor Follows Failure – Entrepreneurs in Action</h2>
                                <p>
                                    Failure is inevitable. It is not when will you fail, but how will you learn from the
                                    coming failure and use it to your advantage to build a business, a career and a
                                    family that is resilient and poised for success. How to unleash the Favor that
                                    follows.
                                </p>
                            </div>
                        </div>


                        <div className="col-lg-4 order-1 order-lg-2">
                            <div className="details">
                                <ul>
                                    <li>
                                        <h3>Check Availability</h3>
                                        <p>Name</p>
                                        <input type="text" placeholder="Your Name" />
                                    </li>
                                    <li>
                                        <p>Email</p>
                                        <input type="text" placeholder="Your Email" />
                                    </li>
                                    <li>
                                        <p>Message</p>
                                        <textarea placeholder="Message" defaultValue={""} />

                                        <button type="submit" className="main-btn main-btn-3">Send Message</button>
                                    </li>
                                </ul>


                            </div>
                        </div>



                        <div className="col-12 order-3">
                            <div className="thumbs">
                                <div className="row justify-content-center">
                                    {imagegallery.map((item, i) => (
                                        <div key={i} className="col-md-4 col-sm-6 text-center">
                                            <img src={item.img} alt="" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>



                        {/* <div className="col-12 order-4">
                            <div className="content">
                                <p>
                                    But I must explain to you how all this mistaken idea of denouncing pleasure and praising
                                    pain was born and I will give you a complete account of the system, and expound the
                                    actual teachings of the great explorer of the truth, the master-builder of human
                                    happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure,
                                    but because those who do not know how to pursue pleasure rationally encounter
                                    consequences that are extremely painful. Nor again is there anyone who loves or pursues
                                    or desires to obtain pain of itself, because it is pain, but because occasionally
                                    circumstances occur in which toil and pain can procure him some great pleasure. To take
                                    a trivial example, which of us ever undertakes laborious physical exercise, except to
                                    obtain some advantage from it? But who has any right to find fault with a man who
                                    chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain
                                    that produces no resultant pleasure
                                </p>
                            </div>
                        </div> */}


                    </div>
                </div>
            </div>
        </section>
    );
}

export default Details;